<template>
  <div class="w-70 mt-12px pr-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">
          Customer Report <span class="gm-italic-font">(Top 4 Customer)</span>
        </div>
        <div
          class="mr-2 pointer"
          @click="goToCustomer()"
          v-if="roles.includes('GET_REPORT_CUSTOMER')"
        >
          <img
            src="../../assets/New-imgs/landing-dashboard/redirect.svg"
            alt=""
          />
        </div>
      </div>
      <div
        style="margin: auto"
        v-if="customSpinner"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div
        v-else-if="noDashBCustReport"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <img src="../../assets/ReportsNew/thirdPartyNodata.svg" alt="" />
      </div>
      <div v-else id="dashCustomer" style="width: 100%; height: 100%"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CustomerGraphDash } from "../../utils/apiFunctions";
import { thirdPartyBar } from "vue-d3-charts-hire3x";

export default {
  props: {
    leadKey: Boolean,
  },
  computed: {
    ...mapGetters(["roles"]),

    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
  },
  created() {
    this.getCustomerGraph();
  },
  data() {
    return {
      customSpinner: true,
      loopvar: 2,
      noDashBCustReport: true,
    };
  },

  methods: {
    goToCustomer() {
      this.$router.push({
        name: "CustomerReport",
        query: {
          status: "dashboard",
        },
      });
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },
    async getCustomerGraph() {
      setTimeout(() => {
        if (document.getElementById("dashCustomer").innerHTML != "") {
          document.getElementById("dashCustomer").innerHTML = "";
        }
      }, 0);
      try {
        const payload = {
          userID: this.roleValues.userID,
          lead: this.leadKey,
        };
        const response = await CustomerGraphDash(payload);
        if (response.status == 200) {
          const myData = response.data.data.data;
          const passData = myData.slice(0, 4);
          this.noDashBCustReport = this.areAllCountsZero(
            passData,
            "openingsCount"
          );
          const myPassData = passData.map((d) => {
            return {
              key: d.name,
              name: d.name,
              count: d.pendingOpening,
              openingsCount: d.openingsCount,
            };
          });
          const width = 1200;
          const height = 290;
          const textXaxis = "No.of Pending Openings";
          setTimeout(() => {
            if (document.getElementById("dashCustomer").innerHTML != "") {
              document.getElementById("dashCustomer").innerHTML = "";
            }
            let e = new thirdPartyBar();
            e.horizontalBarGraph(
              myPassData,
              "#dashCustomer",
              width,
              height,
              textXaxis
            );
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.customSpinner = false;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
